import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Trash2, RotateCcw } from "lucide-react";
import { euro } from "@/lib/format";

const daysLeft = (iso) => Math.max(0, 30 - Math.floor((Date.now() - new Date(iso).getTime()) / 86400000));

export const QuotesTrash = ({ onRestored }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!open) return;
    api.get("/quotes-trash").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [open]);
  const restore = async (it) => {
    try {
      await api.post(`/quotes-trash/${it.id}/restore`);
      setItems((xs) => xs.filter((x) => x.id !== it.id));
      onRestored?.();
      toast.success(`Devis ${it.quote_number} restauré`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <>
      <Button variant="outline" className="gap-2" onClick={() => setOpen(true)} data-testid="quotes-trash-btn"><Trash2 className="w-4 h-4" /> Corbeille</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid="quotes-trash-dialog">
          <DialogHeader>
            <DialogTitle>Corbeille des devis</DialogTitle>
            <DialogDescription>Les devis supprimés sont conservés 30 jours, puis effacés définitivement.</DialogDescription>
          </DialogHeader>
          {items.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="quotes-trash-empty">La corbeille est vide.</p> : (
            <ul className="divide-y max-h-96 overflow-y-auto">
              {items.map((it) => (
                <li key={it.id} className="py-2 flex items-center gap-3" data-testid={`quotes-trash-item-${it.quote_number}`}>
                  <div className="flex-1 min-w-0 text-sm">
                    <div className="font-medium truncate"><span className="font-mono">{it.quote_number}</span> · {it.client || "—"}{it.signed ? " · Commande signée" : ""}</div>
                    <div className="text-xs text-muted-foreground truncate">{it.model_name} · {euro(it.total_public_ttc || 0)}{it.reseller_name ? ` · ${it.reseller_name}` : ""}</div>
                    <div className="text-[11px] text-muted-foreground">Supprimé le {new Date(it.deleted_at).toLocaleDateString("fr-FR")}{it.deleted_by ? ` par ${it.deleted_by}` : ""} · effacé dans {daysLeft(it.deleted_at)} j</div>
                  </div>
                  <Button size="sm" className="gap-1.5" onClick={() => restore(it)} data-testid={`quotes-trash-restore-${it.quote_number}`}>
                    <RotateCcw className="w-3.5 h-3.5" /> Restaurer
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
